<template>
    <div class="offer-pdf m-auto">
        <div class="offer-pdf__header">
            <img alt="" width="200" src="https://www.capture-studio.de/images/capture-studio.jpg">
        </div>
        <hr class="offer-pdf__divider" />
        <h4 class="offer-pdf__headline">Angebot</h4>
        <h1 class="offer-pdf__main-headline"><span v-if="offer.firma != ''">{{offer.firma}}</span><span v-else>{{offer.salutation}} {{offer.name}}</span></h1>
        <p class="offer-pdf__sub-headline">Angebotsnummer: {{ new Date().getFullYear() }} - {{ offer.id }}</p>
        <div class="row offer-pdf__address" v-if="offer.client_id > 0 || (offer.street != '' && offer.zip != '' && offer.city != '')">
            <div class="col-6">
                <div v-if="offer.client">
                    <b v-if="offer.client.company != ''" class="d-block">{{offer.client.company}}</b>
                    <b>{{offer.client.user.salutation}}<span v-if="offer.client.user.pre_name"> {{offer.client.user.pre_name}}</span> {{offer.client.user.name}}</b><br />
                    {{ offer.client.street }}<br />
                    {{ offer.client.zip }}&nbsp;{{ offer.client.city }}<br />
                </div>
                <div v-else>
                    <b v-if="offer.firma != ''">{{offer.firma}}</b>
                    <b v-else>{{offer.name}}</b><br />
                    {{ offer.street }}<br />
                    {{ offer.zip }}<br />
                    {{ offer.city }}<br />
                </div>
            </div>
            <div class="col-6">
                <b>Capture Studio</b><br />
                {{ manager.full_name }}<br />
                Lauchstädter Str. 42a<br />
                04229 Leipzig<br />
                Deutschland
            </div>
        </div>
        <div v-for="offerPart in offerTexts" class="offer-pdf__item" :class="offerPart.type_id == 1 ? 'offer-pdf__item--break' : ''">
            <div v-if="offerPart.type_id != 5">
                <h4 class="offer-pdf__headline">{{ offerPart.headline }}</h4>
                <div class="offer-pdf__text" v-html="offerPart.template"></div>
                <div v-if="offerPart.type_id == 1 && manager.name == 'Sascha'" class="offer-pdf__user-image">
                    <img alt="" width="150" src="https://admin.produktfotografie-24h.de/img/sascha-1.jpg">
                </div>
                <div v-else-if="offerPart.type_id == 1 && manager.name == 'Franzi'" class="offer-pdf__user-image">
                    <img alt="" width="150" src="https://admin.produktfotografie-24h.de/img/franzi-1.jpg">
                </div>
                <div v-else-if="offerPart.type_id == 1 && manager.name == 'Daniela'" class="offer-pdf__user-image">
                    <img alt="" width="150" src="https://admin.produktfotografie-24h.de/img/danie-1.jpg">
                </div>

                <div class="row offer-pdf__service" v-if="offerPart.type_id == 1">
                    <div class="offer-pdf__user-image col-2">
                        <img alt="" height="100" src="https://admin.produktfotografie-24h.de/img/service-2.png">
                    </div>
                    <div class="offer-pdf__user-image col-2">
                        <img alt="" width="100" src="https://admin.produktfotografie-24h.de/img/service-1.png">
                    </div>
                </div>
                <div v-if="offerPart.headline && offerPart.headline.includes('Legeware')">
                    <p class="mt-5 font-weight-bold">Beispiel Bilder</p>
                    <div class="row">
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/legeware-1.jpg" alt="" /></div>
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/legeware-2.jpg" alt="" /></div>
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/legeware-3.jpg" alt="" /></div>
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/legeware-4.jpg" alt="" /></div>
                    </div>
                </div>
                <div v-else-if="offerPart.headline && offerPart.headline.includes('Flaschen')">
                    <p class="mt-5 font-weight-bold">Beispiel Bilder</p>
                    <div class="row">
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/flaschen-1.jpg" alt="" /></div>
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/flaschen-2.jpg" alt="" /></div>
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/flaschen-3.jpg" alt="" /></div>
                        <div class="col-3"><img class="img-fluid" src="https://admin.produktfotografie-24h.de/img/examples/flaschen-4.jpg" alt="" /></div>
                    </div>
                </div>
            </div>
            <div v-else class="offer-pdf__item-price">
                <h4 class="offer-pdf__headline" v-if="offerPart.headline" v-html="offerPart.headline"></h4>
                <div class="offer-pdf__text offer-pdf__text--price" v-html="offerPart.template_short"></div>
                <div class="offer-pdf__text offer-pdf__text--price"> Das Angebot bezieht sich auf ein Volumen von {{ offer.estimation_range }} Bildern.</div>
                <div class="row offer-pdf__price-row-headline mt-3">
                    <div :class="offerTemplate.project_type_id == 21 ? 'col-3' : 'col-6'" class="offer-pdf__price-vert-headline">Unsere Servicepakete</div>
                    <div :class="offerTemplate.project_type_id == 21 ? 'col-9' : 'col-6'">
                        <div class="row offer-pdf__price-headline-row" v-if="offerPart.template.priceCols == 3">
                            <div class="offer-pdf__price-headline-item col-4 text-right">Basic</div>
                            <div class="offer-pdf__price-headline-item col-4 text-right">Standard</div>
                            <div  class="offer-pdf__price-headline-item col-4 text-right">Premium</div>
                        </div>
                        <div class="row offer-pdf__price-headline-row" v-else-if="offerPart.template.priceCols == 2">
                            <div class="offer-pdf__price-headline-item col-6 text-right">Standard</div>
                            <div  class="offer-pdf__price-headline-item col-6 text-right">Premium</div>
                        </div>
                        <div class="row offer-pdf__price-headline-row" v-else-if="offerPart.template.priceCols == 1">
                            <div class="offer-pdf__price-headline-item col-12 text-right">Features</div>
                        </div>
                    </div>
                </div>
                <div v-if="offerTemplate.project_type_id == 21">
                    <div class="offer-pdf__price-row row" v-for="item in offerPart.template.texts">
                        <div class="col-3 offer-pdf__price-vert-headline">{{ item.name }}</div>
                        <div class="col-9">
                            <div class="row" v-if="offerPart.template.priceCols == 1">
                                <div class="offer-pdf__price-item col-12 text-right">
                                    <span v-if="item.price1 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price1 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price1 }}</span>
                                </div>
                            </div>
                            <div class="row" v-else-if="offerPart.template.priceCols == 2">
                                <div class="offer-pdf__price-item col-6 text-right">
                                    <span v-if="item.price1 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price1 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price1 }}</span>
                                </div>
                                <div class="offer-pdf__price-item col-6 text-right">
                                    <span v-if="item.price2 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price2 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price2 }}</span>
                                </div>
                            </div>
                            <div class="row" v-else-if="offerPart.template.priceCols == 3">
                                <div class="offer-pdf__price-item col-4 text-right">
                                    <span v-if="item.price1 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price1 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price1 }}</span>
                                </div>
                                <div class="offer-pdf__price-item col-4 text-right">
                                    <span v-if="item.price2 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price2 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price2 }}</span>
                                </div>
                                <div class="offer-pdf__price-item col-4 text-right">
                                    <span v-if="item.price3 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price3 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price3 }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div  class="offer-pdf__price-row row" v-for="item in offerPart.template.texts">
                        <div class="col-6 offer-pdf__price-vert-headline">{{ item.name }}</div>
                        <div class="col-6">
                            <div class="row" v-if="offerPart.template.priceCols == 1">
                                <div class="offer-pdf__price-item col-12 text-right">
                                    <span v-if="item.price1 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price1 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price1 }}</span>
                                </div>
                            </div>
                            <div class="row" v-else-if="offerPart.template.priceCols == 2">
                                <div class="offer-pdf__price-item col-6 text-right">
                                    <span v-if="item.price1 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price1 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price1 }}</span>
                                </div>
                                <div class="offer-pdf__price-item col-6 text-right">
                                    <span v-if="item.price2 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price2 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price2 }}</span>
                                </div>
                            </div>
                            <div class="row" v-else-if="offerPart.template.priceCols == 3">
                                <div class="offer-pdf__price-item col-4 text-right">
                                    <span v-if="item.price1 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price1 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price1 }}</span>
                                </div>
                                <div class="offer-pdf__price-item col-4 text-right">
                                    <span v-if="item.price2 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price2 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price2 }}</span>
                                </div>
                                <div class="offer-pdf__price-item col-4 text-right">
                                    <span v-if="item.price3 == 'true'"><i class="fa fa-check-circle"></i></span>
                                    <span v-else-if="item.price3 == 'false'"><i class="fa fa-times-circle"></i></span>
                                    <span v-else>{{ item.price3 }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="offerTemplate.project_type_id == 21">
                    <div class="col-3 offer-pdf__price-footer-item offer-pdf__price-vert-headline">Paketpreis</div>
                    <div class="col-9">
                        <div class="row" v-if="offerPart.template.priceCols == 1">
                            <div class="offer-pdf__price-footer-item col-12 text-right"><span v-html="getPrice(offerPart.template.price1, imagePriceCalc) + ' &euro;'"></span></div>
                        </div>
                        <div class="row" v-else-if="offerPart.template.priceCols == 2">
                            <div class="offer-pdf__price-footer-item col-6 text-right"><span v-html="getPrice(offerPart.template.price1, imagePriceCalc) + ' &euro;'"></span></div>
                            <div class="offer-pdf__price-footer-item col-6 text-right"><span v-html="getPrice(offerPart.template.price2, imagePriceCalc) + ' &euro;'"></span></div>
                        </div>
                        <div class="row" v-else-if="offerPart.template.priceCols == 3">
                            <div class="offer-pdf__price-footer-item col-4 text-right"><span v-html="getPrice(offerPart.template.price1, imagePriceCalc) + ' &euro;'"></span></div>
                            <div class="offer-pdf__price-footer-item col-4 text-right"><span v-html="getPrice(offerPart.template.price2, imagePriceCalc) + ' &euro;'"></span></div>
                            <div  class="offer-pdf__price-footer-item col-4 text-right"><span v-html="getPrice(offerPart.template.price3, imagePriceCalc) + ' &euro;'"></span></div>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div  class="col-6 offer-pdf__price-footer-item offer-pdf__price-vert-headline">Preis pro Bild</div>
                    <div class="col-6">
                        <div class="row" v-if="offerPart.template.priceCols == 1">
                            <div class="offer-pdf__price-footer-item col-12 text-right"><span v-html="getPrice(offerPart.template.price1, imagePriceCalc) + ' &euro;'"></span></div>
                        </div>
                        <div class="row" v-else-if="offerPart.template.priceCols == 2">
                            <div class="offer-pdf__price-footer-item col-6 text-right"><span v-html="getPrice(offerPart.template.price1, imagePriceCalc) + ' &euro;'"></span></div>
                            <div class="offer-pdf__price-footer-item col-6 text-right"><span v-html="getPrice(offerPart.template.price2, imagePriceCalc) + ' &euro;'"></span></div>
                        </div>
                        <div class="row" v-else-if="offerPart.template.priceCols == 3">
                            <div class="offer-pdf__price-footer-item col-4 text-right"><span v-html="getPrice(offerPart.template.price1, imagePriceCalc) + ' &euro;'"></span></div>
                            <div class="offer-pdf__price-footer-item col-4 text-right"><span v-html="getPrice(offerPart.template.price2, imagePriceCalc) + ' &euro;'"></span></div>
                            <div  class="offer-pdf__price-footer-item col-4 text-right"><span v-html="getPrice(offerPart.template.price3, imagePriceCalc) + ' &euro;'"></span></div>
                        </div>
                    </div>
                </div>
                <div class="offer-pdf__price-options">
                    <div class="offer-pdf__price-option-headline">Optionale Zusatzoptionen</div>
                    <div class="offer-pdf__price-option-item" v-for="option in upselling" v-if="option.active">
                        <div class="offer-pdf__price-option-item--name">{{ option.name }}</div>
                        <div class="offer-pdf__price-option-item--price">{{ option.price | currency }} pro {{ option.unit }}</div>
                    </div>
                </div>
                <div class="offer-pdf__vat mt-5">* alle Preisangaben zzgl. MwSt.</div>
            </div>
        </div>

        <div class="offer-pdf__item">
            <h4 class="offer-pdf__headline">Auftragsbestätigung</h4>
            <div class="offer-pdf__text">Hiermit erklären Sie sich mit dem Angebot von Capture Studio einverstanden.</div>
            <div class="offer-pdf__sign row justify-content-between  ml-0 mr-0">
                <div class="offer-pdf__offer-confirm col-4"></div>
                <div class="offer-pdf__offer-confirm col-4"></div>
            </div>
            <div class="offer-pdf__sign-label row justify-content-between ml-0 mr-0">
                <div class="offer-pdf__offer-confirm-text col-4 pl-0">Ort, Datum</div>
                <div class="offer-pdf__offer-confirm-text col-4 pl-0">Unterschrift</div>
            </div>
        </div>
    </div>
</template>

<script>
 export default{
     props: {
         offer: Object,
         offerTemplate: Object,
         imagePriceCalc: Number,
         companys: Object,
         selectedCompany: String,
         salutation: String,
         lastname: String,
         manager: Object,
         upselling: Object
     },
     computed:{
         offerTexts(){
             let that = this;
             let tmpArr = [];
             this.offerTemplate.templateParts.forEach(function(item){
                 let templatePart = item[0];

                 if (templatePart.type_id != 5) {
                     let templateStr = templatePart.template;

                     if (that.offer.client){
                         templateStr = templateStr.replaceAll("##salutation##", (that.offer.client.user.salutation) ? that.offer.client.user.salutation : "");
                         templateStr = templateStr.replaceAll("##last_name##", that.offer.client.user.name);
                     }
                     else{
                         templateStr = templateStr.replaceAll("##salutation##", that.offer.salutation);
                         templateStr = templateStr.replaceAll("##last_name##", that.offer.name);
                     }

                     templateStr = templateStr.replaceAll("##employee_name##", that.manager.name);
                     templateStr = templateStr.replaceAll("##employee_job##", that.manager.position);
                     templateStr = templateStr.replaceAll("##company##", that.selectedCompany);

                     tmpArr.push({
                         headline: templatePart.headline,
                         template: templateStr,
                         template_short: templatePart.template_short,
                         type_id: templatePart.type_id,
                     });
                 }
                 else{
                     tmpArr.push(templatePart);
                 }
             });

             return tmpArr;
         }
     },
     methods:{
         getPrice(price1, price2){
             let price = Math.floor(price1 * price2 / 100);
             return price + ",95";
         }
     }

 }
</script>
